import styles from './SeaIce.scss';
import React from 'react';
import clsx from 'clsx';

const RED_VALUES = [
  { label: '<5', color: '#ff649c' },
  { label: '5–10', color: '#f20059' },
  { label: '10–15', color: '#c00046' },
];
const GREEN_VALUES = [
  { label: '15–20', color: '#a1d100' },
  { label: '20–25', color: '#7ba000' },
  { label: '25–30', color: '#617f00' },
];
const PURPLE_VALUES = [
  { label: '30–40', color: '#9d4eff' },
  { label: '40–50', color: '#6a00eb' },
  { label: '50–60', color: '#410091' },
  { label: '>60', color: '#24004f' },
];

const Bar = ({ label, color }) => (
  <div className={styles.legendValue} key={label}>
    <span className={styles.colorbar} style={{ background: color }}></span>
    {label}
  </div>
);

export const IceThicknessLegend = () => (
  <div className={clsx(styles.iceThicknessLegend)} aria-hidden>
    <div>
      {RED_VALUES.map((x) => (
        <Bar {...x} />
      ))}
    </div>
    <div>
      {GREEN_VALUES.map((x) => (
        <Bar {...x} />
      ))}
    </div>
    <div>
      {PURPLE_VALUES.map((x) => (
        <Bar {...x} />
      ))}
    </div>
  </div>
);
